import React, { useContext, useEffect, useRef, useState } from "react";

import styles from "./UIUploadIcon.module.scss";
import { useTranslation } from "react-i18next";
import plus from "../file-icon/plus.png";
import minus from "../file-icon/minus.png";
import folder_write from "../file-icon/folder_write.png";
import upload_icon from "../file-icon/upload_icon.png";

//@ts-ignore
import _ from "lodash";
import { FileContext } from "../File.context";
import { notification } from "antd";
import { calPercentProgressBtnMain, onChangeSelectFileMain, } from "src/service/files.util";

function UIUploadIcon(props: any) {
  const { t, i18n } = useTranslation();
  const fileContext: any = useContext(FileContext);
  const [expandUpload, setExpandUpload] = useState(false);
  const inputFileToUploadEl: any = useRef();

  const getImg = () => {
    if (expandUpload) {
      return <img src={minus} height={5} width={25} />;
    } else {
      return <img src={plus} height={25} width={25} />;
    }
  };

  const onChangeSelectFile = async (event: any) => {
    onChangeSelectFileMain(event, fileContext, inputFileToUploadEl);
  };

  useEffect(() => {
    if (fileContext?.uploadErrorMessage && fileContext?.uploadErrorDescription) {
      notification["error"]({
        message: fileContext?.uploadErrorMessage,
        description: fileContext?.uploadErrorDescription,
      });

      //reset error message
      fileContext.setUploadErrorMessage(null);
      fileContext.setUploadErrorDescription(null);
    }
  }, [fileContext?.uploadErrorMessage, fileContext?.uploadErrorDescription]);

  useEffect(() => {
    if (fileContext.showCreateFolderModal || fileContext.showModalUpload) {
      setExpandUpload(false)
    }
  }, [fileContext.showCreateFolderModal, fileContext.showModalUpload]);

  const checkCanSelectFile = () => {
    let res = calPercentProgressBtnMain(fileContext.fileToUpload);
    if (fileContext.uploading) {
      if (res.status === "cancel") {
        return true;
      } else {
        if (res.percent === 100) return true;
        else return false;
      }
    } else return true;
  };
  const handleClickToSelectFiles = () => {
    if (checkCanSelectFile()) {
      let res = calPercentProgressBtnMain(fileContext.fileToUpload);
      if (res.status === "cancel" || res.percent === 100) {
        fileContext.setFileToUpload(Object.assign([], []));
      }
      fileContext.setUploading(false);
      inputFileToUploadEl.current.click();
    }

  };

  useEffect(() => {
    // console.log("isShared : ", props.isShared);
    // console.log("getRecursiveParents: ", props.getRecursiveParents)
  }, [props.isShared, props.getRecursiveParents])

  const getExpand = () => {
    if (expandUpload) {
      return (
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute" }}>

            {(props.isShared && props.getRecursiveParents?.length > 2) ?
              null : (
                <div
                  style={{
                    display: "flex",
                    marginTop: "22px",
                    transform: "translate(-130px, 0px)",
                  }}
                >
                  <span className={styles.tooltiparrowcontent}></span>
                  <div className={styles.tooltipcontent}>
                    <div className={styles.tooltipinner} role="tooltip">
                      {t("New Folder")}
                    </div>
                  </div>

                  <div
                    className={styles.searchBottonBtn}
                    onClick={() => {
                      fileContext.setShowCreateFolderModal(true);
                    }}
                  >
                    <img src={folder_write} height={22} width={25} />
                  </div>
                </div>
              )
            }


            <div
              style={{
                display: "flex",
                marginTop: "22px",
                transform: "translate(-130px, 0px)",
              }}
            >
              <span className={styles.tooltiparrowcontent}></span>
              <div className={styles.tooltipcontent}>
                <div className={styles.tooltipinner} role="tooltip">
                  {t("Upload Files")}
                </div>
              </div>
              <div
                className={styles.searchBottonBtn}
                onClick={() => {
                  handleClickToSelectFiles();
                }}
              >
                <img src={upload_icon} height={22} width={31} />
              </div>
              <input
                ref={inputFileToUploadEl}
                className={styles.inputfile}
                type="file"
                multiple={!fileContext.isCheckIn}
                onChange={(event) => {
                  onChangeSelectFile(event);
                }}
              ></input>
            </div>
          </div>
        </div>
      );
    } else {
      return <></>;
    }
  };

  return (
    <div>
      <div style={{ display: "flex" }}>
        <div
          className={styles.searchBottonBtn}
          onClick={() => {
            setExpandUpload(!expandUpload);
          }}
        >
          {getImg()}
        </div>
      </div>

      {getExpand()}
    </div>
  );
}

export default UIUploadIcon;
